import { Application } from "@hotwired/stimulus"
import ModalController from "./modal_controller"
import TransactionsController from "./transactions_controller"

const application = Application.start()
application.register("modal", ModalController)
application.register("transactions", TransactionsController)
